import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "banner" }
const _hoisted_2 = {
  key: 0,
  class: "image"
}

import { onMounted, ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'MainPageBanner',
  setup(__props) {

const mounted = ref(false)

onMounted(() => {
    mounted.value = true
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (mounted.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})